/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  GetFinaCertificate200,
  UploadFinaCertificate200,
  UploadFinaCertificateBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Upload a P12/PFX certificate for CIS fiscalization. The certificate will be processed to extract expiry date and stored securely.
 * @summary Upload FINA certificate
 */
export type uploadFinaCertificateResponse200 = {
  data: UploadFinaCertificate200
  status: 200
}

export type uploadFinaCertificateResponse400 = {
  data: Error
  status: 400
}

export type uploadFinaCertificateResponse401 = {
  data: Error
  status: 401
}

export type uploadFinaCertificateResponse403 = {
  data: Error
  status: 403
}

export type uploadFinaCertificateResponse404 = {
  data: Error
  status: 404
}

export type uploadFinaCertificateResponse422 = {
  data: ValidationError
  status: 422
}

export type uploadFinaCertificateResponse500 = {
  data: Error
  status: 500
}

export type uploadFinaCertificateResponseSuccess = (uploadFinaCertificateResponse200) & {
  headers: Headers;
};
export type uploadFinaCertificateResponseError = (uploadFinaCertificateResponse400 | uploadFinaCertificateResponse401 | uploadFinaCertificateResponse403 | uploadFinaCertificateResponse404 | uploadFinaCertificateResponse422 | uploadFinaCertificateResponse500) & {
  headers: Headers;
};

export type uploadFinaCertificateResponse = (uploadFinaCertificateResponseSuccess | uploadFinaCertificateResponseError)

export const getUploadFinaCertificateUrl = () => {


  

  return `/fiscalization/fina/settings/certificate`
}

export const uploadFinaCertificate = async (uploadFinaCertificateBody: UploadFinaCertificateBody, options?: RequestInit): Promise<uploadFinaCertificateResponse> => {
    const formData = new FormData();
if(uploadFinaCertificateBody.file !== undefined) {
 formData.append(`file`, uploadFinaCertificateBody.file);
 }
if(uploadFinaCertificateBody.passphrase !== undefined) {
 formData.append(`passphrase`, uploadFinaCertificateBody.passphrase);
 }

  return customFetch<uploadFinaCertificateResponse>(getUploadFinaCertificateUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}
  

/**
 * Retrieve certificate metadata including expiry date and upload time. Does not return the certificate or private key.
 * @summary Get certificate metadata
 */
export type getFinaCertificateResponse200 = {
  data: GetFinaCertificate200
  status: 200
}

export type getFinaCertificateResponse400 = {
  data: Error
  status: 400
}

export type getFinaCertificateResponse401 = {
  data: Error
  status: 401
}

export type getFinaCertificateResponse403 = {
  data: Error
  status: 403
}

export type getFinaCertificateResponse404 = {
  data: Error
  status: 404
}

export type getFinaCertificateResponse500 = {
  data: Error
  status: 500
}

export type getFinaCertificateResponseSuccess = (getFinaCertificateResponse200) & {
  headers: Headers;
};
export type getFinaCertificateResponseError = (getFinaCertificateResponse400 | getFinaCertificateResponse401 | getFinaCertificateResponse403 | getFinaCertificateResponse404 | getFinaCertificateResponse500) & {
  headers: Headers;
};

export type getFinaCertificateResponse = (getFinaCertificateResponseSuccess | getFinaCertificateResponseError)

export const getGetFinaCertificateUrl = () => {


  

  return `/fiscalization/fina/settings/certificate`
}

export const getFinaCertificate = async ( options?: RequestInit): Promise<getFinaCertificateResponse> => {
  
  return customFetch<getFinaCertificateResponse>(getGetFinaCertificateUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Delete the FINA certificate for the entity. This will remove both the uploaded file reference and the extracted certificate from the database.
 * @summary Delete FINA certificate
 */
export type deleteFinaCertificateResponse204 = {
  data: void
  status: 204
}

export type deleteFinaCertificateResponse400 = {
  data: Error
  status: 400
}

export type deleteFinaCertificateResponse401 = {
  data: Error
  status: 401
}

export type deleteFinaCertificateResponse403 = {
  data: Error
  status: 403
}

export type deleteFinaCertificateResponse404 = {
  data: Error
  status: 404
}

export type deleteFinaCertificateResponse422 = {
  data: ValidationError
  status: 422
}

export type deleteFinaCertificateResponse500 = {
  data: Error
  status: 500
}

export type deleteFinaCertificateResponseSuccess = (deleteFinaCertificateResponse204) & {
  headers: Headers;
};
export type deleteFinaCertificateResponseError = (deleteFinaCertificateResponse400 | deleteFinaCertificateResponse401 | deleteFinaCertificateResponse403 | deleteFinaCertificateResponse404 | deleteFinaCertificateResponse422 | deleteFinaCertificateResponse500) & {
  headers: Headers;
};

export type deleteFinaCertificateResponse = (deleteFinaCertificateResponseSuccess | deleteFinaCertificateResponseError)

export const getDeleteFinaCertificateUrl = () => {


  

  return `/fiscalization/fina/settings/certificate`
}

export const deleteFinaCertificate = async ( options?: RequestInit): Promise<deleteFinaCertificateResponse> => {
  
  return customFetch<deleteFinaCertificateResponse>(getDeleteFinaCertificateUrl(),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

